"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ApiDrop } from "@/generated/models/ObjectSerializer";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ArtistActivityBadge } from "@/components/waves/drops/ArtistActivityBadge";
import { getSubmissionCount, getTrophyArtworkCount } from "@/helpers/artist-activity.helpers";
interface SingleWaveDropAuthorProps {
  readonly drop: ApiDrop;
}
export const SingleWaveDropAuthor: React.FC<SingleWaveDropAuthorProps> = t0 => {
  const $ = _c(35);
  const {
    drop
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInitialTab, setModalInitialTab] = useState("active");
  const submissionCount = getSubmissionCount(drop.author);
  const hasSubmissions = submissionCount > 0;
  const trophyCount = getTrophyArtworkCount(drop.author);
  const hasTrophyArtworks = trophyCount > 0;
  const hasActivityBadge = hasSubmissions || hasTrophyArtworks;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = tab => {
      setModalInitialTab(tab);
      setIsModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleBadgeClick = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleModalClose = t2;
  const t3 = `/${drop.author.handle}`;
  let t4;
  if ($[2] !== drop.author.pfp) {
    t4 = drop.author.pfp ? <div className="tw-h-10 tw-w-10 tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950"><img className="tw-size-full tw-object-contain tw-opacity-90" src={drop.author.pfp} alt="User avatar" /></div> : <div className="tw-h-10 tw-w-10 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-iron-900" />;
    $[2] = drop.author.pfp;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = drop.author.handle ?? drop.author.id;
  let t6;
  if ($[4] !== drop.author.handle) {
    t6 = <span className="tw-text-md tw-font-semibold tw-text-white desktop-hover:hover:tw-text-opacity-80">{drop.author.handle}</span>;
    $[4] = drop.author.handle;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <UserProfileTooltipWrapper user={t5}>{t6}</UserProfileTooltipWrapper>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== drop.author.level) {
    t8 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[9] = drop.author.level;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className="tw-inline-flex tw-items-center tw-gap-x-1">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== drop.id || $[15] !== hasActivityBadge || $[16] !== submissionCount || $[17] !== trophyCount) {
    t10 = hasActivityBadge && <ArtistActivityBadge submissionCount={submissionCount} trophyCount={trophyCount} onBadgeClick={handleBadgeClick} tooltipId={`single-drop-activity-badge-${drop.id}`} />;
    $[14] = drop.id;
    $[15] = hasActivityBadge;
    $[16] = submissionCount;
    $[17] = trophyCount;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <div className="tw-inline-flex tw-items-center tw-gap-x-1">{t10}</div>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t9) {
    t12 = <div className="tw-inline-flex tw-items-center tw-gap-x-2">{t9}{t11}</div>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t3 || $[26] !== t4) {
    t13 = <div className="tw-flex tw-items-start tw-gap-x-2.5"><Link href={t3} className="tw-flex tw-items-center tw-gap-x-2.5 tw-no-underline">{t4}{t12}</Link></div>;
    $[24] = t12;
    $[25] = t3;
    $[26] = t4;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== drop.author || $[29] !== isModalOpen || $[30] !== modalInitialTab) {
    t14 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[28] = drop.author;
    $[29] = isModalOpen;
    $[30] = modalInitialTab;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};